import { extraDataMessageType } from '../types';

export const reducerExtraDataMessage = (contentReplace: string, dataReplace: extraDataMessageType, t: Function) => contentReplace.replace(dataReplace.replace, t(dataReplace.value));
